import React from 'react';
import { TagProps } from 'antd';

import {
  StyledAntdTag,
} from './style';

const CVTag = (props: TagProps): JSX.Element => (
  <StyledAntdTag {...props} />
);

export default CVTag;
